package diana.soleil.design.iraniancanadienbazzar.core.model

import kotlinx.serialization.Serializable

/**
 * One day of platform growth (`platform_metrics/daily-YYYYMMDD`, Functions-maintained): how many
 * accounts and listings were created that day. [day] is the compact ISO day (`20260704`).
 */
@Serializable
data class DailyPlatformCounters(
    val day: String,
    val users: Int = 0,
    val businesses: Int = 0,
)
